import {
  schemes,
  zSchema,
  publicPaginationSchema,
  publicSortSchema,
} from "@zeal/common";

export const getAccrualBalancesRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  q: zSchema.string().optional(),
  policy_type: zSchema.string().optional(),
  ...publicPaginationSchema.shape,
  ...publicSortSchema.shape,
});

export type TGetAccrualBalancesRequestSchema = zSchema.infer<
  typeof getAccrualBalancesRequestSchema
>;

export const getAccrualBalancesResponseSchema = zSchema.array(
  zSchema.object({
    id: schemes.mongoObjectId(),
    employeeID: schemes.mongoObjectId(),
    worker_name: zSchema.string(),
    policy_name: zSchema.string(),
    balance: zSchema.number(),
    created_at: zSchema.string(),
  })
);

export type TGetAccrualBalancesResponseSchema = zSchema.infer<
  typeof getAccrualBalancesResponseSchema
>;
